import { Avatar, Box, Typewriter } from "app/material-framework/materialComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";

const MESSAGES = [
  "Thinking...",
  "Analyzing context...",
  "Connecting to data sources...",
  "Looking into Research reports...",
  "Retrieving results...",
  "Refining insights...",
  "Summarizing findings...",
  "Ranking relevant insights...",
  "Almost there...",
  "This is taking a bit longer...",
  "Still working on it...",
  "Hang tight...",
];

export default function ChatLoadingWidget() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2,
        gap: 1,
        px: 1,
      }}
    >
      <Avatar sx={{ bgcolor: "#737373", color: "#FFFFFFD9" }}>
        <FontAwesomeIcon icon={faRobot} />
      </Avatar>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          p: 1.5,
          borderRadius: 2,
          bgcolor: theme.palette.primary.chatBackground,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          minWidth: 180,
        }}
      >
        <span>
          <Typewriter
            options={{
              strings: MESSAGES,
              autoStart: true,
              loop: true,
              delay: 60,
              deleteSpeed: 20,
              pauseFor: 1200,
            }}
          />
        </span>
      </Box>
    </Box>
  );
}
